import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13c99708"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "OCapacidadeValorLista",
  "data-testid": "OCapacidadeValorLista"
}
const _hoisted_2 = { class: "OCapacidadeValorLista__AdicionarAtributo" }

import { MDropdown } from "@/components/Gerais"
  import { OCapacidadeValor } from "@/components/AtributoComValor"
  import { CapacidadesStore } from "@/store/atributos/capacidades/capacidades.store"

  import { storeToRefs } from "pinia"
  import { onMounted, ref, computed, watch } from "vue"
  import AtributosRepositorio from "@/repositorios/atributos/atributos.repositorio"
  import { AtributoBase, ParamsAtributo } from "@/repositorios/atributos/atributos.modelos"

  import { usarBuscarMaisDados} from "@/composable/UsarBuscarMaisDados/usarBuscarMaisDados"
  import { usarLeitorDeDados } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"

  import { estados } from "@/types/api"
  import { useToast } from "primevue/usetoast"
  import { EntidadeGenerica } from "@/types/gerais"
  import { useI18n } from "vue-i18n"

  interface Props {
    carregando?: boolean
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OCapacidadeValorLista',
  props: {
    carregando: { type: Boolean }
  },
  setup(__props: any) {

  

  const { t } = useI18n()

  const capacidadesStore = CapacidadesStore()
  const { capacidades, estagioDaRequisicao } = storeToRefs(capacidadesStore)
  const { adicionarCapacidade, removerCapacidade } = capacidadesStore

  const atributosRep = new AtributosRepositorio()

  const { buscarMaisDados, filtrarDadosDoRepositorio, atualizarDadosDoRepositorio  } = usarBuscarMaisDados()
  const { leitor } = usarLeitorDeDados()

  const toast = useToast()
  const capacidadeSelecionada = ref<AtributoBase<string>>()
  const capacidadesDropdown = ref<AtributoBase<boolean>[]>([])
  const capacidadesEntidadeGenerica = ref<EntidadeGenerica[]>([])

  const estaCarregandoCapacidades = computed(() => {
    return lerAtributos.resultado.status === 'pendente'
  })

  const estaCarregandoCapacidadesStore = computed (() => {
    return estagioDaRequisicao.value === estados.PEDENTE
  })

  const lerAtributos = leitor<AtributoBase, ParamsAtributo>(
    atributosRep.listarAtributos, {
      tipo_do_atributo: "igual.capacidade",
      "por-pagina": 30
    }
  )

  const atributoDuplicado = (id: string): boolean => {
    return capacidades.value.some((caracterisitica) => caracterisitica.id === id)
  }

  const mostrarAvisoDeCapacidadeDuplicada = (): void => {
    toast.add({
      severity: "info",
      summary: t("duplicado"),
      detail: t("capacidadeJaFoiAdicionada"),
      closable: true,
      life: 4000,
    })
  }

  const adicionarCapacidadeNaLista = (): void => {
    const capacidade = capacidadeSelecionada.value

    if (capacidade) {
      const jaTemCapacidade = atributoDuplicado(capacidade.id!)

      if (jaTemCapacidade) {
        mostrarAvisoDeCapacidadeDuplicada()
      } else {
        adicionarCapacidade({
          id: capacidade.id!,
          nomeDoAtributo: capacidade.nome,
          periodosDeConsumo: capacidade.periodosDeConsumo!,
          deletavel: true,
        })
      }
    }
  }

  const buscarMaisAtributos = async (): Promise<void> => {
    await buscarMaisDados(lerAtributos, capacidadesEntidadeGenerica)
  }

  const filtrarAtributos = async (valorInserido: string): Promise<void> => {
    await filtrarDadosDoRepositorio(valorInserido, lerAtributos, capacidadesEntidadeGenerica)
  }

  const listaTodosOsAtributosCapacidades = async (): Promise<void> => {
    await lerAtributos.executar()

    if (lerAtributos.resultado.status === "sucesso") {
      capacidadesDropdown.value = lerAtributos.resultado.dados

      await atualizarDadosDoRepositorio(lerAtributos, capacidadesEntidadeGenerica)
    }
  }

  watch(capacidadesEntidadeGenerica, () => {
    if (lerAtributos.resultado.status === 'sucesso') {
      capacidadesDropdown.value = lerAtributos.resultado.dados
    }
  })

  onMounted(async () => {
    try {
      await listaTodosOsAtributosCapacidades()
    } catch (erro) {
      console.error(erro)
    }
  })

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_PButton = _resolveComponent("PButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(estaCarregandoCapacidadesStore) || __props.carregando)
      ? (_openBlock(), _createBlock(_component_Skeleton, {
          key: 0,
          height: "8rem",
          style: {"margin-bottom":"2rem"},
          width: "100%"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(capacidades), (capacidade, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: capacidade.id,
              class: "OCapacidadeValorLista__Capacidade"
            }, [
              _createVNode(_unref(OCapacidadeValor), {
                "id-atributo": capacidade.id,
                indice: i,
                nome: capacidade.nomeDoAtributo,
                "tipo-de-valor": capacidade.tipoDoValor
              }, null, 8, ["id-atributo", "indice", "nome", "tipo-de-valor"]),
              (capacidade.deletavel)
                ? (_openBlock(), _createBlock(_component_PButton, {
                    key: 0,
                    onClick: ($event: any) => (_unref(removerCapacidade)(capacidade.id)),
                    class: "OCapacidadeValorLista__Remover p-button-rounded p-button-text",
                    "data-testid": "OcapacidadeValorLista__Remover",
                    icon: "pi pi-trash"
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(MDropdown), {
        modelValue: capacidadeSelecionada.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((capacidadeSelecionada).value = $event)),
        onOnFiltrandoBusca: filtrarAtributos,
        "buscar-mais-itens": buscarMaisAtributos,
        carregando: _unref(estaCarregandoCapacidades),
        class: "OCapacidadeValorLista__Dropdown",
        desativado: _unref(estaCarregandoCapacidadesStore) || __props.carregando,
        nome: "adicionar-atributo-capacidade",
        "option-label": "nome",
        options: capacidadesDropdown.value,
        placeholder: _unref(t)('atributo'),
        "usar-carregamento-sob-demanda": ""
      }, null, 8, ["modelValue", "carregando", "desativado", "options", "placeholder"]),
      _createVNode(_component_PButton, {
        onClick: adicionarCapacidadeNaLista,
        class: "OCapacidadeValorLista__Button p-button-success",
        disabled: _unref(estaCarregandoCapacidadesStore) || __props.carregando,
        label: _unref(t)('adicionarCapacidade')
      }, null, 8, ["disabled", "label"])
    ])
  ], 64))
}
}

})